// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.login_auth-card__g3Qc\\+ {
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 28px;
  padding: 24px 22px 22px;
  box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);
  width: 100%;
  max-width: 420px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.login_auth-card__form__lG7oU {
  width: 100%;
}
.login_auth-card__case__JjRh1 {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.14);
  border: 1px solid rgba(130, 177, 148, 0.24);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #739F84;
}
.login_auth-card__title__hujl8 {
  margin: 14px 0 6px;
  font-size: 28px;
  line-height: 1.02;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: #13231D;
}
.login_auth-card__intro__4R-yY {
  margin: 0 0 18px;
  color: rgba(19, 35, 29, 0.68);
  font-size: 13px;
  line-height: 1.55;
}
.login_auth-card__tabs__nxQX1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid rgba(16, 25, 21, 0.12);
  margin-bottom: 20px;
}
.login_auth-card__tab__ChbiT {
  padding: 12px 0 13px;
  text-align: center;
  color: rgba(19, 35, 29, 0.68);
  font-size: 13px;
  text-decoration: none;
}
.login_auth-card__tab--active__-fB2z {
  color: #3D4642;
  font-weight: 700;
  border-bottom: 2px solid #82B194;
  margin-bottom: -1px;
}
.login_auth-card__fields__PThzK {
  display: grid;
  gap: 12px;
}
.login_auth-card__field-group__XDanI {
  min-height: 42px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 14px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.5) inset;
}
.login_auth-card__field-group__XDanI .MuiInputBase-root {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #26312D;
}
.login_auth-card__field-group__XDanI .MuiInputBase-root::before, .login_auth-card__field-group__XDanI .MuiInputBase-root::after {
  display: none;
}
.login_auth-card__field-group__XDanI .MuiInputBase-root .MuiInputBase-input::placeholder {
  color: rgba(19, 35, 29, 0.46) !important;
  opacity: 1;
}
.login_auth-card__field-group__XDanI:focus-within {
  border-color: rgba(130, 177, 148, 0.48);
  background: rgba(130, 177, 148, 0.14);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.1);
}
.login_auth-card__field-group__XDanI:focus-within .MuiInputBase-input {
  color: #26312D;
}
.login_auth-card__field-group--filled__iGzQb .MuiInputBase-input {
  color: #26312D;
}
.login_auth-card__field-group--error__ndJga {
  border-color: #C95C5C !important;
  box-shadow: 0 0 0 4px rgba(201, 92, 92, 0.12) !important;
  background: rgba(201, 92, 92, 0.02);
}
.login_auth-card__eye__kA\\+d3 {
  color: rgba(19, 35, 29, 0.46) !important;
}
.login_auth-card__helper-links__rkyp3 {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 12px;
}
.login_auth-card__remember__B-GwE {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6A7A73;
  cursor: pointer;
}
.login_auth-card__checkbox-box__ep3wt {
  width: 13px;
  height: 13px;
  border: 1px solid rgba(16, 25, 21, 0.18);
  background: #F6F7F5;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.login_auth-card__checkbox-box--active__1KeDp {
  background-color: #82B194;
  border-color: #82B194;
}
.login_auth-card__checkbox-box--active__1KeDp::after {
  content: "✓";
  color: white;
  font-size: 9px;
}
.login_auth-card__forgot__ObtTg {
  color: #6A7A73;
  text-decoration: none;
}
.login_auth-card__btn-primary__rGPuZ {
  margin-top: 22px;
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  background: #82B194;
  color: #fff;
  border: none;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.2s ease;
}
.login_auth-card__btn-primary__rGPuZ:hover {
  background: #739F84;
}
.login_auth-card__divider__kWfoP {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 16px;
  color: #9AA39F;
  font-size: 11px;
}
.login_auth-card__divider__kWfoP::before, .login_auth-card__divider__kWfoP::after {
  content: "";
  height: 1px;
  background: rgba(16, 25, 21, 0.12);
  flex: 1 1;
}
.login_auth-card__btn-google__0LQxc {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 42px;
  border-radius: 14px;
  border: 1px solid rgba(16, 25, 21, 0.12);
  background: #F7F5F1;
  font-weight: 600;
  color: #13231D;
  cursor: pointer;
}
.login_auth-card__gmark__L0ZQH {
  font-weight: 900;
  font-size: 18px;
  color: #4285F4;
}
.login_auth-card__link-home__IehZm {
  display: flex;
  justify-content: center;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #739F84;
  text-decoration: none;
}
.login_auth-card__legal__QLgEh {
  margin: 18px 0 0;
  text-align: center;
  font-size: 11px;
  line-height: 1.55;
  color: rgba(19, 35, 29, 0.46);
}
.login_auth-card__legal__QLgEh a {
  color: #739F84;
  text-decoration: none;
}
@media (max-width: 480px) {
  .login_auth-card__g3Qc\\+ {
    padding: 20px 16px 18px;
    border-radius: 24px;
  }
  .login_auth-card__title__hujl8 {
    font-size: 24px;
  }
  .login_auth-card__tabs__nxQX1 {
    margin-bottom: 16px;
  }
  .login_auth-card__tab__ChbiT {
    font-size: 12px;
    padding: 10px 0;
  }
  .login_auth-card__fields__PThzK {
    gap: 10px;
  }
  .login_auth-card__field-group__XDanI {
    min-height: 40px;
    border-radius: 12px;
  }
  .login_auth-card__btn-primary__rGPuZ, .login_auth-card__btn-google__0LQxc {
    min-height: 40px;
    border-radius: 12px;
    font-size: 13px;
  }
  .login_auth-card__helper-links__rkyp3 {
    font-size: 11px;
    margin-top: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACyIhB;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AD5IJ;;AAfA;EACI,mBCgBmB;EDfnB,wCAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,WAAA;EACA,gBAAA;EACA,oFCJQ;ADsBZ;AAhBI;EACI,WAAA;AAkBR;AAfI;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,qCAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cChBe;ADiCvB;AAdI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cCbe;AD6BvB;AAbI;EACI,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAeR;AAZI;EACI,aAAA;EACA,8BAAA;EACA,+CAAA;EACA,mBAAA;AAcR;AAXI;EACI,oBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;AAaR;AAXQ;EACI,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AAaZ;AATI;EACI,aAAA;EACA,SAAA;AAWR;AARI;EACI,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAAA;AAUR;AARQ;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAUZ;AATY;EAAsB,aAAA;AAYlC;AATgB;EACI,wCAAA;EACA,UAAA;AAWpB;AANQ;EACI,uCAAA;EACA,qCAAA;EACA,8CAAA;AAQZ;AANY;EACI,cAAA;AAQhB;AAHY;EACI,cAAA;AAKhB;AADQ;EACI,gCAAA;EACA,wDAAA;EACA,mCAAA;AAGZ;AACI;EACI,wCAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AADR;AAII;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAFR;AAIQ;EACI,yBC7IW;ED8IX,qBC9IW;AD4IvB;AAGY;EACI,YAAA;EACA,YAAA;EACA,cAAA;AADhB;AAMI;EACI,cAAA;EACA,qBAAA;AAJR;AAOI;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBCjKe;EDkKf,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AALR;AAOQ;EACI,mBCxKW;ADmKvB;AASI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAPR;AASQ;EACI,WAAA;EACA,WAAA;EACA,kCAAA;EACA,SAAA;AAPZ;AAWI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBC9Le;ED+Lf,gBAAA;EACA,cC3Le;ED4Lf,eAAA;AATR;AAYI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAVR;AAaI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAXR;AAcI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAZR;AAcQ;EACI,cAAA;EACA,qBAAA;AAZZ;AAgBI;EAlPJ;IAmPQ,uBAAA;IACA,mBAAA;EAbN;EAeM;IACI,eAAA;EAbV;EAgBM;IACI,mBAAA;EAdV;EAiBM;IACI,eAAA;IACA,eAAA;EAfV;EAkBM;IACI,SAAA;EAhBV;EAmBM;IACI,gBAAA;IACA,mBAAA;EAjBV;EAoBM;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;EAlBV;EAqBM;IACI,eAAA;IACA,gBAAA;EAnBV;AACF","sourcesContent":["@import \"../../assets/styles/variables.scss\";\n\n.auth-card {\n    background: $color-surface; \n    border: 1px solid rgba(12, 36, 28, 0.08);\n    border-radius: 28px;\n    padding: 24px 22px 22px;\n    box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);\n    width: 100%;\n    max-width: 420px;\n    font-family: $font-main;\n\n    &__form{\n        width: 100%;\n    }\n\n    &__case {\n        display: inline-flex;\n        align-items: center;\n        min-height: 24px;\n        padding: 0 10px;\n        border-radius: 999px;\n        background: rgba(130, 177, 148, 0.14);\n        border: 1px solid rgba(130, 177, 148, 0.24);\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: .06em;\n        text-transform: uppercase;\n        color: $color-primary-hover;\n    }\n\n    &__title {\n        margin: 14px 0 6px;\n        font-size: 28px;\n        line-height: 1.02;\n        letter-spacing: -0.03em;\n        font-weight: 800;\n        color: $text-main;\n    }\n\n    &__intro {\n        margin: 0 0 18px;\n        color: rgba(19, 35, 29, 0.68);\n        font-size: 13px;\n        line-height: 1.55;\n    }\n\n    &__tabs {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        border-bottom: 1px solid rgba(16, 25, 21, 0.12);\n        margin-bottom: 20px;\n    }\n\n    &__tab {\n        padding: 12px 0 13px;\n        text-align: center;\n        color: rgba(19, 35, 29, 0.68);\n        font-size: 13px;\n        text-decoration: none;\n\n        &--active {\n            color: #3D4642;\n            font-weight: 700;\n            border-bottom: 2px solid $color-primary;\n            margin-bottom: -1px;\n        }\n    }\n\n    &__fields {\n        display: grid;\n        gap: 12px;\n    }\n\n    &__field-group {\n        min-height: 42px;\n        border: 1px solid rgba(12, 36, 28, 0.08);\n        border-radius: 14px;\n        background: #FFFFFF;\n        display: flex;\n        align-items: center;\n        padding: 0 12px;\n        box-shadow: 0 1px 0 rgba(255, 255, 255, 0.5) inset;\n\n        :global(.MuiInputBase-root) {\n            width: 100%;\n            font-size: 14px;\n            font-weight: 500;\n            color: #26312D;\n            &::before, &::after { display: none; }\n\n            :global(.MuiInputBase-input) {\n                &::placeholder {\n                    color: rgba(19, 35, 29, 0.46) !important;\n                    opacity: 1;\n                }\n            }\n        }\n\n        &:focus-within {\n            border-color: rgba(130, 177, 148, .48);\n            background: rgba(130, 177, 148, .14);\n            box-shadow: 0 0 0 3px rgba(130, 177, 148, .10);\n            \n            :global(.MuiInputBase-input) {\n                color: #26312D;\n            }\n        }\n\n        &--filled {\n            :global(.MuiInputBase-input) {\n                color: #26312D;\n            }\n        }\n\n        &--error {\n            border-color: $color-error !important;\n            box-shadow: 0 0 0 4px rgba(201, 92, 92, .12) !important;\n            background: rgba(201, 92, 92, 0.02);\n        }\n    }\n\n    &__eye {\n        color: rgba(19, 35, 29, 0.46) !important;\n    }\n\n    &__helper-links {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 14px;\n        font-size: 12px;\n    }\n\n    &__remember {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        color: #6A7A73;\n        cursor: pointer;\n    }\n\n    &__checkbox-box {\n        width: 13px;\n        height: 13px;\n        border: 1px solid rgba(16, 25, 21, 0.18);\n        background: #F6F7F5;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s ease;\n\n        &--active {\n            background-color: $color-primary;\n            border-color: $color-primary;\n            &::after {\n                content: \"✓\";\n                color: white;\n                font-size: 9px;\n            }\n        }\n    }\n\n    &__forgot {\n        color: #6A7A73;\n        text-decoration: none;\n    }\n\n    &__btn-primary {\n        margin-top: 22px;\n        width: 100%;\n        min-height: 44px;\n        border-radius: 14px;\n        background: $color-primary;\n        color: #fff;\n        border: none;\n        font-weight: 800;\n        cursor: pointer;\n        transition: background 0.2s ease;\n\n        &:hover {\n            background: $color-primary-hover;\n        }\n    }\n\n    &__divider {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin: 18px 0 16px;\n        color: #9AA39F;\n        font-size: 11px;\n\n        &::before, &::after {\n            content: \"\";\n            height: 1px;\n            background: rgba(16, 25, 21, 0.12);\n            flex: 1;\n        }\n    }\n\n    &__btn-google {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        min-height: 42px;\n        border-radius: 14px;\n        border: 1px solid rgba(16, 25, 21, 0.12);\n        background: $color-surface;\n        font-weight: 600;\n        color: $text-main;\n        cursor: pointer;\n    }\n\n    &__gmark {\n        font-weight: 900;\n        font-size: 18px;\n        color: #4285F4;\n    }\n\n    &__link-home {\n        display: flex;\n        justify-content: center;\n        margin-top: 4px;\n        font-size: 12px;\n        font-weight: 700;\n        color: #739F84;\n        text-decoration: none;\n    }\n\n    &__legal {\n        margin: 18px 0 0;\n        text-align: center;\n        font-size: 11px;\n        line-height: 1.55;\n        color: rgba(19, 35, 29, 0.46);\n\n        a {\n            color: #739F84;\n            text-decoration: none;\n        }\n    }\n\n    @media (max-width: 480px) {\n        padding: 20px 16px 18px;\n        border-radius: 24px;\n\n        &__title {\n            font-size: 24px;\n        }\n\n        &__tabs {\n            margin-bottom: 16px;\n        }\n\n        &__tab {\n            font-size: 12px;\n            padding: 10px 0;\n        }\n\n        &__fields {\n            gap: 10px;\n        }\n\n        &__field-group {\n            min-height: 40px;\n            border-radius: 12px;\n        }\n\n        &__btn-primary, &__btn-google {\n            min-height: 40px;\n            border-radius: 12px;\n            font-size: 13px;\n        }\n\n        &__helper-links {\n            font-size: 11px;\n            margin-top: 12px;\n        }\n    }\n}","\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves."],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth-card": `login_auth-card__g3Qc+`,
	"auth-card__form": `login_auth-card__form__lG7oU`,
	"auth-card__case": `login_auth-card__case__JjRh1`,
	"auth-card__title": `login_auth-card__title__hujl8`,
	"auth-card__intro": `login_auth-card__intro__4R-yY`,
	"auth-card__tabs": `login_auth-card__tabs__nxQX1`,
	"auth-card__tab": `login_auth-card__tab__ChbiT`,
	"auth-card__tab--active": `login_auth-card__tab--active__-fB2z`,
	"auth-card__fields": `login_auth-card__fields__PThzK`,
	"auth-card__field-group": `login_auth-card__field-group__XDanI`,
	"auth-card__field-group--filled": `login_auth-card__field-group--filled__iGzQb`,
	"auth-card__field-group--error": `login_auth-card__field-group--error__ndJga`,
	"auth-card__eye": `login_auth-card__eye__kA+d3`,
	"auth-card__helper-links": `login_auth-card__helper-links__rkyp3`,
	"auth-card__remember": `login_auth-card__remember__B-GwE`,
	"auth-card__checkbox-box": `login_auth-card__checkbox-box__ep3wt`,
	"auth-card__checkbox-box--active": `login_auth-card__checkbox-box--active__1KeDp`,
	"auth-card__forgot": `login_auth-card__forgot__ObtTg`,
	"auth-card__btn-primary": `login_auth-card__btn-primary__rGPuZ`,
	"auth-card__divider": `login_auth-card__divider__kWfoP`,
	"auth-card__btn-google": `login_auth-card__btn-google__0LQxc`,
	"auth-card__gmark": `login_auth-card__gmark__L0ZQH`,
	"auth-card__link-home": `login_auth-card__link-home__IehZm`,
	"auth-card__legal": `login_auth-card__legal__QLgEh`
};
export default ___CSS_LOADER_EXPORT___;
